import { Column } from 'react-table'
import GetUrls from 'ts/enums/Url'
import { UserType } from 'ts/types/UserType'
import { Boolean } from 'components/ui'
import CardTable from 'components/CardTable'
import UserTypeAddPage from './UserTypeAddPage'

const columns: Column<UserType>[] = [
  {
    Header: 'ID',
    accessor: 'userTypeId'
  },
  {
    Header: 'Active',
    accessor: 'flPowerUser',
    Cell: ({ value }) => <Boolean value={value} />
  },
  {
    Header: 'Type Name',
    accessor: 'name'
  }
]

const UserTypePage = () => {
  const Url = GetUrls();
  return (
  <CardTable
    columns={columns}
    dataKey={Url.getUserType.toString()}
    url={Url.getUserType}
    modalChild={<UserTypeAddPage />}
  />
)}

export default UserTypePage
